// Type:"Temporary"
// Type:"Permanent"

export const rowsEngg = [

  {
    SNo: 1,
    CollegeCode: "U4",
    CollegeName: "Dadi Inst of Engg & Tech, Anakapalli",
    District: "ANKP",
    "College Type": "Engineering",
    wURL: "https://www.diet.edu.in/",
    Type: "Permanent",
  },
  {
    SNo: 2,
    CollegeCode: "6E",
    CollegeName:
      "Gonna Institute of Information Technology & Science, Aganampudi",
    District: "ANKP",
    "College Type": "Engineering",
    wURL: "https://giits.in/",
    Type: "Temporary",
  },
  {
    SNo: 3,
    CollegeCode: "6J",
    CollegeName: "Simhadhri Educational Socity Group of Inst, Sabbavaram",
    District: "ANKP",
    "College Type": "Engineering",
    wURL: "https://simhadhri.org/",
    Type: "Temporary",
  },
  {
    SNo: 4,
    CollegeCode: "A5",
    CollegeName: "Aditya Inst of Tech & Manag, Tekkali",
    District: "SKL",
    "College Type": "Engineering",
    wURL: "https://www.adityatekkali.edu.in/",
    Type: "Permanent",
  },
  {
    SNo: 5,
    CollegeCode: "MT",
    CollegeName:
      "Sri Venkateswara College of Engineering & Technology, Etcherla",
    District: "SKL",
    "College Type": "Engineering",
    wURL: "http://svcet.info/index.php",
    Type: "Temporary",
  },
  {
    SNo: 6,
    CollegeCode: "W6",
    CollegeName: "Sri Sivani College Of Engg,Chilakalapalem,Srikakulam",
    District: "SKL",
    "College Type": "Engineering",
    wURL: "https://srisivani.com/",
    Type: "Temporary",
  },
  {
    SNo: 7,
    CollegeCode: "98",
    CollegeName: "Raghu Engineering College, Bheemili",
    District: "VSP",
    "College Type": "Engineering",
    wURL: "https://raghuenggcollege.com/",
    Type: "Permanent",
  },
  {
    SNo: 8,
    CollegeCode: "L3",
    CollegeName: "Vignans Institute of Information Technology, Gajuwaka",
    District: "VSP",
    "College Type": "Engineering",
    wURL: "https://vignaniit.edu.in/",
    Type: "Permanent",
  },
  {
    SNo: 9,
    CollegeCode: "L6",
    CollegeName: "Chaitanya Engineering College,Madhurawada",
    District: "VSP",
    "College Type": "Engineering",
    wURL: "http://cec.ac.in/",
    Type: "Temporary",
  },
  {
    SNo: 10,
    CollegeCode: "NM",
    CollegeName: "Vignans Institute of Engineering for Women, Gajuwaka",
    District: "VSP",
    "College Type": "Engineering",
    wURL: "http://www.view.edu.in/",
    Type: "Permanent",
  },
  {
    SNo: 11,
    CollegeCode: "NR",
    CollegeName: "Baba Institute of Technology & Science, Madhurawada",
    District: "VSP",
    "College Type": "Engineering",
    wURL: "https://bitsvizag.com/",
    Type: "Temporary",
  },
  {
    SNo: 12,
    CollegeCode: "NT",
    CollegeName: "Visakha Institute of Engineering & Technology, Narava",
    District: "VSP",
    "College Type": "Engineering",
    wURL: "https://vietvsp.com/",
    Type: "Permanent",
  },
  {
    SNo: 13,
    CollegeCode: "NU",
    CollegeName:
      "Nadimpalli  Satyanarayana Raju Institute of Technology, Sontyam",
    District: "VSP",
    "College Type": "Engineering",
    wURL: "http://www.nsrit.edu.in/",
    Type: "Permanent",
  },
  {
    SNo: 14,
    CollegeCode: "6F",
    CollegeName: "Sai Ganapathi Engineering College, Anandapuram",
    District: "VSP",
    "College Type": "Engineering",
    wURL: "http://www.sgec.edu.in/",
    Type: "Temporary",
  },

  {
    SNo: 15,
    CollegeCode: "34",
    CollegeName: "GMR Institute of Technology,Rajam",
    District: "VZM",
    "College Type": "Engineering",
    wURL: "http://www.gmrit.org/",
    Type: "Permanent",
  },
  {
    SNo: 16,
    CollegeCode: "33",
    CollegeName: "MVGR College of Engineering, Chinthalavalasa.",
    District: "VZM",
    "College Type": "Engineering",
    wURL: "https://www.mvgrce.com/",
    Type: "Permanent",
  },
  {
    SNo: 17,
    CollegeCode: "99",
    CollegeName:
      "Avanthis St. Theressa Institute of Engineering & Technology, Garividi",
    District: "VZM",
    "College Type": "Engineering",
    wURL: "http://avanthi.edu.in/sttheressa/",
    Type: "Temporary",
  },
  {
    SNo: 18,

    CollegeCode: "HQ",
    CollegeName: "Avanthis Research & Technological Academy, Bhogapuram",
    District: "VZM",
    "College Type": "Engineering",
    wURL: "https://arta.ac.in/",
    Type: "Temporary",
  },
  {
    SNo: 19,
    CollegeCode: "KD",
    CollegeName: "Lendi Institute of Engineering & Technology, Denkada",
    District: "VZM",
    "College Type": "Engineering",
    wURL: "https://www.lendi.org/",
    Type: "Permanent",
  },
  
   {
    SNo: 20,
    CollegeCode: "81",
    CollegeName: "Avanthi Inst of Engineering & Technology, Narsipatnam",
    District: "ANKP",
    "College Type": "Engineering",
    wURL: "https://avanthienggcollege.ac.in/",
     Type: "Permanent",
  },
  {
    SNo: 21,
    CollegeCode: "6C",
    CollegeName:
      "Miracle Educational Society Group of Institutions, Bhogapuram",
    District: "VZM",
    "College Type": "Engineering",
    wURL: "https://miracle.edu.in/",
    Type: "Permanent",
  },
  {
    SNo: 22,
    CollegeCode: "8K",
    CollegeName: "Gokul Group of Institutions, Bobbili",
    District: "VZM",
    "College Type": "Engineering",
    wURL: "http://www.gokulcollege.com/",
    Type: "Temporary",
  },
  {
    SNo: 23,
    CollegeCode: "B6",
    CollegeName: "Satya Institute of Technology & Management, Gajularega.",
    District: "VZM",
    "College Type": "Engineering",
    wURL: "https://www.sitam.co.in/",
    Type: "Permanent",
  },
  {
    SNo: 24,
    CollegeCode: "PC",
    CollegeName: "N S Raju Institute of Engineering and Technology Dakamarri(V), Bheemunipatnam(M)",
    District: "VSP",
    "College Type": "Engineering",
    wURL: "https://www.nsriet.edu.in/",
    Type: "Temporary",
  },

  {
    SNo: 25,
    CollegeCode: "V1",
    CollegeName: " Behara College of Engineering and Technology",
    District: "VSP",
    "College Type": "Engineering",
    wURL: "http://WWW.bcet.in",
    Type: "Temporary",
  },

];

export const rowsPharmacy = [
  {
    SNo: 1,
    CollegeCode: "DA",
    CollegeName: "Sri Sivani College of Pharmacy, Srikakulam",
    District: "SKL",
    "College Type": "Pharmacy",
    wURL: "https://www.shiksha.com/college/sri-sivani-college-of-pharmacy-srikakulam-61185",
    Type: "Temporary",
  },
  {
    SNo: 2,
    CollegeCode: "AC",
    CollegeName: "Vignan Inst Pharmaceutical Technology, Gajuwaka",
    District: "VSP",
    "College Type": "Pharmacy",
    wURL: "https://www.careers360.com/colleges/vignan-institute-of-pharmaceutical-technology-gajuwaka",
    Type: "Permanent",
  },
  {
    SNo: 3,
    CollegeCode: "PK",
    CollegeName: "Viswanadha Inst of Pharmaceuticel Sciences,Anandapuram",
    District: "VSP",
    "College Type": "Pharmacy",
    wURL: "http://vnips.in/Home.html",
    Type: "Temporary",
  },
  {
    SNo: 4,
    CollegeCode: "B7",
    CollegeName: "Emmanuel College of Pharmacy, Singanna Banda",
    District: "VSP",
    "College Type": "Pharmacy",
    wURL: "https://ecops.co.in/",
    Type: "Temporary",
  },
  {
    SNo: 5,
    CollegeCode: "T5",
    CollegeName: "Avanthi Institute of Phramaceutical Sciences,Bhogapuram",
    District: "VZM",
    "College Type": "Pharmacy",
    wURL: "https://avanthipharma.ac.in/",
    Type: "Temporary",
  },
  
  {
    SNo: 6,
    CollegeCode: "HH",
    CollegeName: "Gokul College of Pharamacy,Bhibbili",
    District: "VZM",
    "College Type": "Pharmacy",
    wURL: "http://www.gokulcollege.com/sites/Pharmacy/contactus.html",
    Type: "Temporary",
  },
];

export const rowsMba = [
  {
    SNo: 1,
    CollegeCode: "8M",
    CollegeName: "Visakha Institute of Management Science, Bheemili",
    District: "VSP",
    CollegeType: "Management",
    wURL: "https://www.collegedekho.com/colleges/visakha-institute-of-management-science",
    Type: "Temporary",
  },
  {
    SNo: 2,
    CollegeCode: "C4",
    CollegeName:
      "All Saints P.G.College, Singanabanda, Bheemili(M), Visakhapatnam",
    District: "VSP",
    CollegeType: "Management",
    wURL: "https://entrance-exam.net/all-saints-pg-college-visakhapatnam-andhra-pradesh/",
    Type: "Temporary",
  },
];
